import React, {Component} from "react";
import {connect} from "react-redux";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import {showToastForBackend} from "../../../actions/toastActions";
import PanelLayout from "../components/PanelLayout";
import SelectBox from "../components/SelectBox";

class ContextToFirstPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputContextPropertyName: this.props.clickedNodeInfo.extras.options.inputContextPropertyName
        }

        this.handleChange = this.handleChange.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
    }

    updateOptions() {
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let panelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(panelInfo.extras, "options")) {
            panelInfo.extras.options = {};
        }
        panelInfo.extras.options = this.state;
        this.props.clickedNodeAction(panelInfo);
    }

    handleChange(property, value) {
        this.setState(prevState => ({
            ...prevState,
            [property]: value
        }), () => {
            this.updateOptions();
        });
    }

    render() {
        return (
            <PanelLayout>
                <div className="filter-group">
                    <div className="filter-group-header">
                        <label className="checkbox-wrapper">Context property</label>
                    </div>
                    <div className="filter-group-content">
                        <div className="filter-rule">
                            <div className="input-container">
                                <SelectBox key="contextProperty"
                                           handleChangeSelect={(event) => this.handleChange("inputContextPropertyName", event.target.value)}
                                           selectValue={this.state.inputContextPropertyName !== undefined ? this.state.inputContextPropertyName : ""}
                                           selectArray={this.props.contextProperties.map(function (contextProperty) {
                                               return {label: contextProperty.name, value: contextProperty.name}
                                           })}
                                           hideArrow={true}
                                           showDefault={true}/>
                            </div>
                        </div>
                    </div>
                </div>
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        contextProperties: state.contextProperties,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo,
        properties: state.properties
    }
}

export default connect(mapStateToProps, {
    clickedNodeAction,
    showToastForBackend
})(ContextToFirstPanel);